import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=654da324&scoped=true&ts=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=654da324&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654da324"]])

export default __exports__